import React from 'react';
import {
  WeatherContainer,
  CurrentTemp,
  MetaTemp,
  MetaTempLocation,
  MetaTempDescription,
  MetaTempRainPresumption,
} from './WeatherWidget.styles';

const WeatherWidget = ({ data }) => {
  const currentWeather = data[0].data.current;
  const forecastWeather = data[0].data.hourly;

  return (
    <WeatherContainer>
      <CurrentTemp>{`${Math.ceil(currentWeather.temp)} °C`}</CurrentTemp>
      <MetaTemp>
        <MetaTempLocation>Wesel-Bislich</MetaTempLocation>
        <MetaTempDescription>
          {currentWeather.weather[0].description}
        </MetaTempDescription>
        <MetaTempRainPresumption>{`Regen: ${Math.ceil(
          forecastWeather[0].pop * 100
        )} %`}</MetaTempRainPresumption>
      </MetaTemp>
    </WeatherContainer>
  );
};

export default WeatherWidget;
